import { DetailsComponent } from './../details/details.component';
import { Injectable } from '@angular/core';
import { Headers, Http, RequestOptions } from '@angular/http';
import { Router } from '@angular/router';
import { DialogService } from 'ng2-bootstrap-modal';

import { environment } from '../../environments/environment';
import { APIURLS, SHAREDCONSTANTS } from '../_constants/constants';
import { KycDetails, KycUpdateData } from './../_models/data.structures';
import { NotificationDialogComponent } from './../notification/notification.dialog.component';
import { CustomerService } from './customer.service';
import { LoaderService } from '../_services/loader.service';


@Injectable()
export class KYCService {
    private kycData: KycDetails;
    constructor(private router: Router, private http: Http, private loaderService: LoaderService) {
    }

    getCustomerKYCData(subValue: string, opcoValue: string, customerService: CustomerService) {
        DetailsComponent.incrementRunningRequests();
        this.loaderService.display(true);
      
        const URL = (environment.BASE_URL_BACKEND + APIURLS.CUSTOMER_KYC).replace('{sub}', subValue);
        const headers = new Headers();

        headers.append('Accept', 'application/json; charset=utf-8');
        headers.append('x-int-opco-id', opcoValue);
        const options = new RequestOptions({ headers: headers, withCredentials: true });
        console.log("KYC URL: " + URL);
        this.http.get(URL, options).subscribe(
            res => {
                DetailsComponent.decrementRunningRequests();
                this.loaderService.display(false);
                this.kycData = res.json();
                if (this.kycData.history !== undefined) {
                    this.kycData.history = this.kycData.history.slice().reverse();
                }
                //const etag = res.headers.get('ETag');
                const etag = res.json().ETag;
                if (etag && etag.length > 0) {
                    customerService.setEtag(etag);
                }
                console.log("KYC Success: " + res.json());
            },
        err => {
            DetailsComponent.decrementRunningRequests();
            this.loaderService.display(false);
            console.log("KYC Error: " + err);
        });
    }

    getKycData(): KycDetails {
        return this.kycData;
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/kyc.service.ts